module.exports = __webpack_public_path__ + "media/images/shark/BlueOcean_3-646faca9157fbdae52cb95dea1ddf44f.jpg";